import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '../cookieconsent-custom.css';

const CookieConsentBanner = () => {
    useEffect(() => {
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "box inline",
                    position: "bottom left",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },
            categories: {
                necessary: {
                    readOnly: true,
                    enabled: true
                },
                analytics: {
                    enabled: false
                },
                marketing: {
                    enabled: false
                }
            },
            language: {
                default: "en",
                autoDetect: "browser",
                translations: {
                    en: {
                        consentModal: {
                            title: "We use cookies!",
                            description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "<a href='/privacy-policy'>Privacy Policy</a>\n<a href='/terms-of-service'>Terms of Service</a>"
                        },
                        preferencesModal: {
                            title: "Cookie preferences",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            closeIconLabel: "Close modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies. <a href='/privacy-policy' class='cc-link'>Privacy Policy</a>"
                                },
                                {
                                    title: "Strictly Necessary Cookies <span class='pm__badge'>Always Enabled</span>",
                                    description: "These cookies are essential for the proper functioning of the website and cannot be disabled.",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Analytics Cookies",
                                    description: "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. We use Google Analytics to improve our services.",
                                    linkedCategory: "analytics",
                                    cookieTable: {
                                        headers: {
                                            name: "Name",
                                            domain: "Domain",
                                            expiration: "Expiration",
                                            description: "Description"
                                        },
                                        body: [
                                            {
                                                name: "_ga",
                                                domain: "rdsstudio.co.za",
                                                expiration: "2 years",
                                                description: "Google Analytics cookie for tracking user behavior"
                                            },
                                            {
                                                name: "_gid",
                                                domain: "rdsstudio.co.za",
                                                expiration: "24 hours",
                                                description: "Google Analytics cookie for distinguishing users"
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: "Marketing Cookies",
                                    description: "These cookies are used to track visitors across websites and display relevant advertisements. We use Facebook Pixel for marketing purposes.",
                                    linkedCategory: "marketing",
                                    cookieTable: {
                                        headers: {
                                            name: "Name",
                                            domain: "Domain",
                                            expiration: "Expiration",
                                            description: "Description"
                                        },
                                        body: [
                                            {
                                                name: "_fbp",
                                                domain: "rdsstudio.co.za",
                                                expiration: "3 months",
                                                description: "Facebook Pixel cookie for ad targeting and analytics"
                                            }
                                        ]
                                    }
                                },
                                {
                                    title: "More information",
                                    description: "For any queries in relation to our policy on cookies and your choices, please <a class='cc-link' href='/contact'>contact us</a>."
                                }
                            ]
                        }
                    }
                }
            },
            onConsent: ({ cookie }) => {
                updateGoogleConsent(
                    cookie.categories.includes('analytics'),
                    cookie.categories.includes('marketing')
                );
                
                // Load Facebook Pixel if marketing accepted
                if (cookie.categories.includes('marketing')) {
                    loadFacebookPixel();
                }
            },
            onChange: ({ changedCategories }) => {
                updateGoogleConsent(
                    CookieConsent.acceptedCategory('analytics'),
                    CookieConsent.acceptedCategory('marketing')
                );
                
                if (changedCategories.includes('marketing') && CookieConsent.acceptedCategory('marketing')) {
                    loadFacebookPixel();
                }
            }
        });
    }, []);

    // Update Google Consent Mode v2 signals
    const updateGoogleConsent = (analyticsGranted, adsGranted) => {
        if (!window.gtag) return;
        window.gtag('consent', 'update', {
            'analytics_storage': analyticsGranted ? 'granted' : 'denied',
            'ad_storage': adsGranted ? 'granted' : 'denied',
            'ad_user_data': adsGranted ? 'granted' : 'denied',
            'ad_personalization': adsGranted ? 'granted' : 'denied',
        });
        // Re-send config to the correct property after consent update
        if (analyticsGranted) {
            window.gtag('config', 'G-54ZYTNFEPB');
        }
    };

    // Load Facebook Pixel
    const loadFacebookPixel = () => {
        if (window.fbq) return; // Already loaded
        
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', '1172494521541032');
        window.fbq('track', 'PageView');
    };

    return null; // This component doesn't render anything
};

export default CookieConsentBanner;
